export default {
  'code': 0,
  'message': 'success',
  'foreignTotal': [{
    'country': '俄罗斯',
    'confirm': 2,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '加拿大',
    'confirm': 4,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '印度',
    'confirm': 3,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '尼泊尔',
    'confirm': 1,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '德国',
    'confirm': 12,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 2,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '2',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '意大利',
    'confirm': 2,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '斯里兰卡',
    'confirm': 1,
    'suspect': 0,
    'dead': 0,
    'heal': 1,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '新加坡',
    'confirm': 18,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '日本',
    'confirm': 20,
    'suspect': 0,
    'dead': 0,
    'heal': 1,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '柬埔寨',
    'confirm': 1,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '法国',
    'confirm': 6,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '泰国',
    'confirm': 19,
    'suspect': 0,
    'dead': 0,
    'heal': 7,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '澳大利亚',
    'confirm': 12,
    'suspect': 0,
    'dead': 0,
    'heal': 2,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '瑞典',
    'confirm': 1,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '美国',
    'confirm': 16,
    'suspect': 0,
    'dead': 0,
    'heal': 1,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '芬兰',
    'confirm': 1,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '英国',
    'confirm': 2,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '菲律宾',
    'confirm': 2,
    'suspect': 0,
    'dead': 1,
    'heal': 0,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '越南',
    'confirm': 9,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 1,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '1',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '阿联酋',
    'confirm': 5,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 0,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '0',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '韩国',
    'confirm': 16,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 1,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '1',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }, {
    'country': '马来西亚',
    'confirm': 10,
    'suspect': 0,
    'dead': 0,
    'heal': 0,
    'modifyConfirm': 2,
    'modifySuspect': 0,
    'modifyDead': 0,
    'modifyHeal': 0,
    'modifyConfirmDesc': '2',
    'modifySuspectDesc': '0',
    'modifyDeadDesc': '0',
    'modifyHealDesc': '0'
  }],
  'recentTime': '2020-02-04 16:15:21'
}
